const customTypography = {
  fonts: {
    body: `'NanumSquare', 'Noto Sans KR', 'Spoqa Han Sans Neo', 'Helvetica Neue', 'Open Sans', Inter, sans-serif`,
    heading: `'NanumSquare', 'Noto Sans KR', 'Spoqa Han Sans Neo', 'Helvetica Neue', 'Open Sans', Inter, sans-serif`,
    mono: `'NanumSquare', Menlo, Inter, monospace`,
  },
};

export default customTypography;
